export const SIPrefix: { name: string; prefix: string; multiply: number }[] = [
  { name: 'nano', prefix: 'n', multiply: 1e9 },
  { name: 'micro', prefix: 'μ', multiply: 1e6 },
  { name: 'mili', prefix: 'm', multiply: 1e3 },
  { name: 'SI', prefix: '', multiply: 1 },
  { name: 'kilo', prefix: 'k', multiply: 1e-3 },
  { name: 'mega', prefix: 'M', multiply: 1e-6 },
  { name: 'giga', prefix: 'G', multiply: 1e-9 },
];
